import { Skeleton } from '@mui/material';
import { Box, BoxProps, Stack } from '@mui/system';
import { Types } from '@scorenco/core';

type CompetitionRankingColumnGpProps = BoxProps & {
  ranking?: Types.Competitions_Ranking_Detail;
};

export const CompetitionRankingColumnGp = ({
  ranking,
  sx,
  ...rest
}: CompetitionRankingColumnGpProps) => {
  let children;
  if (!ranking) {
    children = <Skeleton width={25} />;
  } else {
    children = (
      <Stack
        direction="row"
        width="100%"
        justifyContent="center"
        alignItems="center"
        gap="0.1rem"
      >
        <Box sx={{ color: 'win.main' }}>
          {ranking?.win as number | undefined}
        </Box>
        <Box>-</Box>
        <Box sx={{ color: 'lost.main' }}>
          {ranking?.lost as number | undefined}
        </Box>
      </Stack>
    );
  }

  return (
    <Box
      sx={{
        flex: '0 0 2.8rem',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
